// src/com/arrival_to_store/ArrivalToStoreView.js
import React from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import { AppStyle, AppWord } from '../../value/AppConst';
import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { LabelCell, ViewerCloserBox } from '../../common/TopStyle';
import { useReactiveVar } from '@apollo/client';
import { authTableTreeRepo } from '../../value/AppModel';
import { useAuthorizationCheck } from '../../api/app-hook';

const DetailBox = styled(Box)({
    marginTop: '0.5rem', paddingBottom: '0.5rem',
    borderBottom: '1px solid #ccc',
    //borderRadius: '0.5rem',
    backgroundColor: '#fff',
});

const DetailHeader = styled(Box)({
    backgroundColor: '#eee', color: AppStyle.PrimaryRGB, // padding: '0.5rem',
    border: '1px solid #ddd', padding: '0.5rem',
    borderTopLeftRadius: '0.5rem', borderTopRightRadius: '0.5rem',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
});

/**
 * 점포관리 상세정보.
 */
export default function ArrivalToStoreView({
    item,
    onClose,
    onRequestOpenReturnInput
}) {
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();
    const canSave = checkAuth(authTableTree.tree.pr_trans_plan_return_save);

    return(
        <DetailBox>
            <DetailHeader>
                <span>{item.dcName}</span>
                <span style={{marginLeft: '1rem', marginRight: '1rem'}}>...</span>
                <span>{item.storeName}</span>
                <div style={{flexGrow: 1, textAlign: 'right'}}>
                    <Button
                        variant={AppStyle.mui.contained} size={AppWord.SMALL}
                        onClick={()=> onRequestOpenReturnInput(item)}
                    >
                        상세정보{canSave ? '등록' : ''}
                    </Button>
                </div>
            </DetailHeader>
            <TableContainer component={Paper}>
                <Table size={AppWord.SMALL}>
                    <TableBody>
                        <TableRow>
                            <LabelCell>출발지</LabelCell>
                            <TableCell>{item.dcName}</TableCell>
                            <LabelCell>도착지</LabelCell>
                            <TableCell>{item.storeName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>호차</LabelCell>
                            <TableCell>{item.hocha}</TableCell>
                            <LabelCell>차량번호</LabelCell>
                            <TableCell>{item.vehPlates}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>운송사</LabelCell>
                            <TableCell>{item.comName}</TableCell>
                            <LabelCell>봉인번호</LabelCell>
                            <TableCell>{item.sealNo1} {item.sealNo2} {item.sealNo3}</TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell>기사명</LabelCell>
                            <TableCell>{item.driverName}</TableCell>
                            <LabelCell>기사전화</LabelCell>
                            <TableCell>
                                {
                                    item.driverMobile && item.driverMobile.length > 9 ?
                                    <a href={`tel:${item.driverMobile}`}>
                                    {item.driverMobile}
                                    </a>
                                    : '(없음)'
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell colSpan={2}>도착 예상시간</LabelCell>
                            <TableCell colSpan={2} style={{backgroundColor:'#e4efff'}}>
                                {item.prosArrTime}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <LabelCell colSpan={2}>실제차량 도착시간</LabelCell>
                            <TableCell colSpan={2} style={{backgroundColor:'#e4efff'}}>
                                {item.inputArrTime}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
            <ViewerCloserBox onClick={onClose} />
        </DetailBox>
    );
}
/*

				<tr>	
					<th colspan="2">도착 예상시간</th> 
					<td colspan="2" style="background-color:#e4efff;"><label class="pros_arr_time" ></label></td>
				</tr>
				<tr>	
					<th colspan="2">실제차량 도착시간</th> 
					<td colspan="2" style="background-color:#e4efff;"><label class="input_arr_date_time" ></label></td>
				</tr>

*/